import { DashboardUtils } from "../../../dashboard_utils";

export function BackButton(props: { label: string; onClick: () => void }) {
	return (
		<div
			className="flex w-min items-center gap-2 whitespace-nowrap font-bold text-sesh-primary hover:cursor-pointer hover:text-sesh-dark"
			onClick={props.onClick}
		>
			{DashboardUtils.GetBackIcon()}
			{props.label}
		</div>
	);
}
